<template>
    <div class="d-flex-column text-left">
        <label v-if="label" class="m-b-md text-bold">
            <i v-if="icon" :class="icon"></i> {{ label }}
        </label>

        <select
            class="filter-select"
            :value="modelValue"
            @change="toggleOption($event.target.value)"
        >
            <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'FilterNew',
    props: {
        options: {
            type: Array,
            required: true,
            validator: (value) => value.every(opt => 'value' in opt && 'label' in opt)
        },
        modelValue: {
            type: String,
            default: 'all'
        },
        label: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        }
    },
    emits: ['update:modelValue'],
    methods: {
        toggleOption(value) {
            this.$emit('update:modelValue', value);
        }
    }
}
</script>
